import { render } from "./Deactivated.vue?vue&type=template&id=204224f2&scoped=true"
import script from "./Deactivated.vue?vue&type=script&lang=js"
export * from "./Deactivated.vue?vue&type=script&lang=js"

import "./Deactivated.vue?vue&type=style&index=0&id=204224f2&lang=scss&scoped=true"

import exportComponent from "/opt/project/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-204224f2"]])

export default __exports__